import centreLocator from "./centre-locator.vue";
import slotSelector from "./slot-selector.vue";
import studentDetails from "./student-details.vue";
import Vuelidate from "vuelidate";
import Vue from "vue/dist/vue.js";
import VueRouter from "vue-router";
import axios from "axios";

import { library } from '@fortawesome/fontawesome-svg-core';
import { faSpinner, faClock, faWifi, faMapMarkerAlt, faEdit, faCheck, faLocationArrow, faInfoCircle, faArrowRight, faCalendar} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Vue.use(Vuelidate);
Vue.use(VueRouter);

library.add(faSpinner, faClock, faWifi, faMapMarkerAlt, faEdit, faCheck, faLocationArrow, faInfoCircle, faArrowRight, faCalendar);
Vue.component('font-awesome-icon', FontAwesomeIcon);

new Vue({
  el: "#app",
  components: {
    centreLocator: centreLocator,
    slotSelector: slotSelector,
    studentDetails: studentDetails
  },
  router: new VueRouter({
    mode: "history",
    routes: []
  }),
  data: {
    selectedCentre: null,
    selectedTime: null,
    lead: false,
    slotType: "",
    centreLocationId: 0,
    networkError: false,
    superCentreId: null,
    campaignId: 0,
    requestedDate: '',
    initialCentreSelected: false,
    isInCentreOnlyCentre: false,
    isFinishedLoadingSlots: false,
    hasLocalCentre: false,
    isNotSuitableTime: false,
    parameterCentre: '',
    isCorporate: false,
    slotsLoaded: false,
    locationName: '',
    userSelectedCentre: null
  },
  validations: {},
  watch: {
    selectedCentre: function() {
      // trigger if and only if centre is set
      if (this.selectedCentre && this.slotType !== "") {
        // This will ensure if any direct centre id coming in,
        // if the id is greater than defined limit,
        // update it to the default direct centre id for api's.
        if(+this.selectedCentre.id >= +dummyDirectCentreId) {
          this.selectedCentre.id = directCentreId;
          this.selectedCentre.phone = this.selectedCentre.centrePhone;
        }
        this.superCentreId = this.selectedCentre.id;
        this.$refs.slotSelector.init();
      }
    },
    slotType: function() {
      this.$refs.slotSelector.selectedSlot = null;
      this.$refs.slotSelector.selectedIndex = null;
    }
  },
  mounted: function() {
    var selectedCentre = JSON.parse(sessionStorage.getItem("bookedCentre"));
    if (selectedCentre) {
      this.selectedCentre = selectedCentre;
    }

    if (this.$route.query.isInCentre) {
      this.slotType = 'C';
    }

    this.campaignId = this.getCampaignIdFromQueryString();

    if(this.$route.query.isOnline && !this.$route.query.centreId) {
      axios.get("centres.json").then(response => {
        var centres = response.data;
        var selectedCentre = centres.find(
          centre => centre.name === 'Online');
        if (selectedCentre) {
          this.selectedCentre = selectedCentre;
          this.isCorporate = selectedCentre.isCorporate;
        }
      });
    }
    if (this.$route.query.centreId) {
      axios.get("centres.json").then(response => {
        var centres = response.data;
        var selectedCentre = centres.find(
          centre => +centre.id === +this.$route.query.centreId
        );
        if (selectedCentre) {
          this.parameterCentre = selectedCentre.address;
          this.isCorporate = selectedCentre.isCorporate;
          this.$refs.centreLocator.search(selectedCentre.id);
        }
      });
    }
  },
  methods: {
    reset: function() {
      this.selectedCentre = null;
      this.initialCentreSelected = false;
      this.selectedTime = null;
      this.lead = false;
      this.slotType = "";
      this.centreLocationId = 0;
      this.superCentreId = null;
      this.isInCentreOnlyCentre = false;
      this.isNotSuitableTime = false;
      this.hasLocalCentre = false;
      this.isInCentreOnlyCentre = false;
      this.isFinishedLoadingSlots = false;
      this.$refs.slotSelector.reset();
      this.$refs.centreLocator.reset();

      if(this.$refs.studentDetails != undefined) {
        this.$refs.studentDetails.reset();
      }
    },
    getCampaignIdFromQueryString() {
      const campaign = this.$route.query.campaign;
      return (campaign) ? campaign : 0;
    },
    resetSlotSelection: function() {
      this.$refs.slotSelector.reset();

      if(this.$refs.studentDetails != undefined) {
        this.$refs.studentDetails.reset();
      }
    },
    resetDirect: function() {
      this.$refs.slotSelector.isDirectCentre = false;
    }
  }
});
